import { jsx as _jsx } from "react/jsx-runtime";
const FCSAlternateADIConfirm = () => {
    return (_jsx("div", { className: "container sub-wrap d-flex justify-content-center align-items-center", children: _jsx("div", { className: "list-header", children: _jsx("h2", { children: "Your alternate account details has been successfully updated." }) }) }));
};
export { FCSAlternateADIConfirm };
